import { UserUploadedIcon } from "react-migration/domains/sites/components/Icons/UserUploadedIcon";
import { SiteStageSelect } from "react-migration/domains/sites/components/SiteStageSelect";
import { SiteSourceType } from "react-migration/domains/sites/typings/Site";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { useSiteById } from "react-migration/domains/sites/hooks/useSiteById";
import { LayerTypeSelectionHeaderProps } from "../../types";
import { SitePageControls } from "./SitePageControls";

export function SiteDetailHeader({ selection, setSelection }: LayerTypeSelectionHeaderProps) {
  const siteId = selection.id;
  const { t } = useTranslation();
  const { site } = useSiteById(siteId);

  return (
    <div className="flex flex-row items-start w-full gap-x-2">
      <SiteStageSelect site={site} />
      <div className="flex flex-col items-stretch grow">
        <div className="text-xs font-semibold text-text-base-tertiary">{t("selection.site_title")}</div>
        <div className="text-sm font-semibold text-text-base-primary line-clamp-3" title={site?.title}>
          {site?.title}
        </div>
      </div>
      <div className="pt-1">
        <UserUploadedIcon
          showIcon={site?.source?.__typename == SiteSourceType.SiteSourceSitesUploader}
          className="self-center px-[7px]! py-[5px]!"
        />
      </div>
      <SitePageControls siteId={siteId} setSelection={setSelection} />
    </div>
  );
}
